import { FC } from 'react'

import { ISvgClass } from '../interface'

const CloseIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.0002 13.4905L6.78351 18.7072C6.58833 18.9024 6.33991 19 6.03827 19C5.73662 19 5.4882 18.9024 5.29302 18.7072C5.09784 18.512 5.00024 18.2636 5.00024 17.962C5.00024 17.6603 5.09784 17.4119 5.29302 17.2167L10.5097 12L5.29302 6.78327C5.09784 6.58809 5.00024 6.33967 5.00024 6.03802C5.00024 5.73638 5.09784 5.48796 5.29302 5.29278C5.4882 5.09759 5.73662 5 6.03827 5C6.33991 5 6.58833 5.09759 6.78351 5.29278L12.0002 10.5095L17.217 5.29278C17.4122 5.09759 17.6606 5 17.9622 5C18.2639 5 18.5123 5.09759 18.7075 5.29278C18.9027 5.48796 19.0002 5.73638 19.0002 6.03802C19.0002 6.33967 18.9027 6.58809 18.7075 6.78327L13.4907 12L18.7075 17.2167C18.9027 17.4119 19.0002 17.6603 19.0002 17.962C19.0002 18.2636 18.9027 18.512 18.7075 18.7072C18.5123 18.9024 18.2639 19 17.9622 19C17.6606 19 17.4122 18.9024 17.217 18.7072L12.0002 13.4905Z"
        fill="inherit"
      />
    </svg>
  )
}

export default CloseIcon
